import React from 'react';
import logoImage from '../assets/images/faire_logo.png';

const Menu = () => {
  return (
    <div className="menu_wrap">
      <header className="menu_navbar_wrap">
        <div className="menu_navbar_contain u-grid-custom">
          <div id="w-node-bbcc6f25-1e6a-a105-cd53-aa50e1d2fbe3-e1d2fbe0" className="menu_navbar_left">
            <div data-split-text="" className="navbar_home_text u-text-h3">
              {logoImage && (
                <img src={logoImage} alt="" style={{width: '250px'}} />
              )}
            </div>
          </div>
          <div id="w-node-bbcc6f25-1e6a-a105-cd53-aa50e1d2fbe7-e1d2fbe0" className="menu_navbar_btn">
            <div className="menu_navbar_space">
              <button data-contact-btn="" data-wf--btn-main--variant="base" className="btn_default_wrap">
                <div className="btn_default_contain">
                  <div data-link="" className="btn_default_text">상담신청</div>
                </div>
                <div className="g_circle is-light"></div>
              </button>
            </div>
            <button data-menu-close="" data-link-hover="" className="menu_navbar_close">
              <div data-link="" className="menu_navbar_text u-text-small">Close</div>
            </button>
          </div>
        </div>
      </header>
      <div className="menu_contain">
        <div className="menu_links_ul">
          <div className="menu_links_li">
            <a href="/" data-link-hover="" className="menu_links_link w-inline-block w--current">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_links_text u-text-h2">Home</div>
                </div>
              </div>
            </a>
          </div>
          <div className="menu_links_li">
            <a href="/works" data-link-hover="" className="menu_links_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_links_text u-text-h2">Works</div>
                </div>
              </div>
            </a>
          </div>
          <div className="menu_links_li">
            <a href="/studio" data-link-hover="" className="menu_links_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_links_text u-text-h2">Studio</div>
                </div>
              </div>
            </a>
          </div>
          <div className="menu_links_li">
            <a href="/process" data-link-hover="" className="menu_links_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_links_text u-text-h2">Process</div>
                </div>
              </div>
            </a>
          </div>
          <div className="menu_links_li">
            <a href="/gallery" data-link-hover="" className="menu_links_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_links_text u-text-h2">Gallery</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="menu_bottom u-text-small">
        <div className="menu_legal_contain">
          <a data-link-hover="" href="https://www.instagram.com/oh.architecture/" target="_blank" rel="noopener noreferrer" className="menu_legal_link w-inline-block">
            <div className="menu_contain_text">
              <div className="menu_contain_link">
                <div data-link="" className="menu_legal_text">instagram</div>
              </div>
            </div>
          </a>
        </div>
        <div className="menu_legal_links">
          <div className="menu_legal_contain">
            <a href="/privacy-policy" data-link-hover="" className="menu_legal_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_legal_text">Privacy policy</div>
                </div>
              </div>
            </a>
          </div>
          <div className="menu_legal_contain">
            <a href="/terms-of-service" data-link-hover="" className="menu_legal_link w-inline-block">
              <div className="menu_contain_text">
                <div className="menu_contain_link">
                  <div data-link="" className="menu_legal_text">terms of service</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;